import { store, getContext } from "@wordpress/interactivity";

const { state } = store("filterable-posts", {
  state: {
    get filteredPosts() {
      const { posts, searchQuery } = state;
      const q = searchQuery.trim().toLowerCase();
      if (!q) return posts;
      return posts.filter((p) => p.titolo.toLowerCase().includes(q));
    },

    get visibleIds() {
      return new Set(
        state.filteredPosts.slice(0, state.visibleCount).map((p) => p.id),
      );
    },

    get getItemDisplay() {
      const { postId } = getContext();
      return state.visibleIds.has(postId) ? "block" : "none";
    },

    get emptyDisplay() {
      return state.filteredPosts.length === 0 ? "block" : "none";
    },

    get loadMoreDisplay() {
      return state.filteredPosts.length > state.visibleCount ? "flex" : "none";
    },
  },

  actions: {
    setSearch(event) {
      state.searchQuery = event.target.value;
      state.visibleCount = state.perPage + 1;
      setTimeout(updateFirstVisible, 0);
    },

    loadMore() {
      state.visibleCount += state.perPage;
      setTimeout(updateFirstVisible, 0);
    },
  },
});

// ── Aggiorna classe first-visible ─────────────────────────────────────────
function updateFirstVisible() {
  const grid = document.querySelector(".filterable-posts .fp-grid");
  if (!grid) return;

  grid.querySelectorAll(".fp-item").forEach((item) => {
    item.classList.remove("is-first-visible");
  });

  const firstVisible = [...grid.querySelectorAll(".fp-item")].find(
    (item) => item.style.display !== "none",
  );

  if (firstVisible) firstVisible.classList.add("is-first-visible");
}

// ── Inizializzazione al caricamento ───────────────────────────────────────
document.addEventListener("DOMContentLoaded", () => {
  const grid = document.querySelector(".filterable-posts .fp-grid");
  if (!grid) return;

  const observer = new MutationObserver(() => {
    updateFirstVisible();
  });

  observer.observe(grid, {
    attributes: true,
    attributeFilter: ["style"],
    subtree: true,
  });

  setTimeout(() => observer.disconnect(), 2000);
});
